import { render } from "./SideMenu.vue?vue&type=template&id=61e3ddec"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61e3ddec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61e3ddec', __exports__)) {
    console.log('reload')
    api.reload('61e3ddec', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=61e3ddec", () => {
    console.log('re-render')
    api.rerender('61e3ddec', render)
  })

}


export default __exports__